var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sidemenu',{attrs:{"hidden-print":""}}),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }